import { ChildsModel } from '../lookupsManagement/ChildsModel';
export class oneRecord {
    arabicName: string;
    englishName: string;
    id: number;
    childs: ChildsModel[];
    parentId?: number;
}
